import * as React from 'react';
import styles from './index.less';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import TopMenuStore from './store';
import Link from '@src/components/link';

/**
 * 移动端游戏顶部导航
 * 如果需要跳转到具体的节点, 需要在需要跳转的部分, 加入
 * <Element name="menuListId" className="new-classic-appointment-part" />
 * menuListId - 对应的节点id, 匹配menuList中的id值
 * @param store
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */

const TopMenu = ({ store, ...rest }) => {
  store.use();

  const login = () => {
    return (
      <div
        className={styles.login}
        onClick={() => {
          store.bookModal?.open();
        }}
      >
        <Link> 登录</Link>
      </div>
    );
  };

  const infoOut = () => {
    return (
      <div className={styles.infoOutBox}>
        <div className={styles.phone}>{store.phone}</div>
        <Link className={styles.exitBtn} onClick={store.onExitBtnClick}>
          退出
          <span className={styles.exitBtn_icon} />
        </Link>
      </div>
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.content} data-name="背景">
        <div className={styles.logo} data-name="ICON" />
        <Link className={styles.indexEntry} href="https://www.mechabreak.cn/" target="_blank" onClick={() => { }} data-name="进入官网按钮" />
        {/* <div className={styles.followUsBtn} onClick={() => store.followUsModal?.open()} data-name="关注我们" /> */}

        <div
          className={styles.menuBtn}
          data-name="下拉选项按钮"
          onClick={() => {
            store.onchangeMenu(true);
          }}
        />
      </div>

      <div ref={store.menuRef} className={cx(styles.menuContent, store.menuState ? styles.menuAct : '')} data-name="下拉导航">
        <div
          className={cx(store.menuState ? styles.menuClose : styles.menuList)}
          onClick={() => {
            store.onchangeMenu(false);
          }}
        />

        <div className={styles.menuTabList}>
          {store.navList?.map((tab, index) => {
            return (
              <Link
                key={index}
                className={cx(styles.topMenuText, store.currentIndex === index && styles.topMenuActive, styles['menuText' + tab.id])}
                onClick={() => {
                  store.clickMenu(tab.id, tab.url, index);
                }}
              >
                {/* {index === 1 && <div className={styles.hot} />} */}
                {tab.name}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(TopMenu, TopMenuStore);
